export interface CidadeDTO {
  codigoCepCidade: number;
  codigoIbge: number;
  nome: string;
}
